export const URL_CUSTOMER_GET_LIST = `/customer/list`;
export const URL_CUSTOMER_GET_DETAIL = `/customer/get`;
export const URL_CUSTOMER_UPDATE = `/customer/cap-nhat`;
export const URL_GET_DATA_FOOTER = '/common/thong-tin-customer';
